// extracted by mini-css-extract-plugin
export var displayNone = "_ro-6";
export var imgContainer = "_ro-2";
export var overflowHidden = "_ro-3";
export var productInfoCardButtonContainer = "_ro-5";
export var productTitleText = "_ro-4";
export var rightArrow = "_ro-1";
export var rightArrowContainer = "_ro-0";